<div *ngIf="!isWizard">
  <div class="sub-header">{{'onboarding.heartlands.update_config' | translate}}</div>

  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.heartlands.select_station' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.heartlands.select_station_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-shopping-basket"></i></span>
        <p-dropdown [options]="locations" [(ngModel)]="config.StationID"
        (onChange)="onStationChange($event)"
                    placeholder="{{'onboarding.heartlands.select_station_placeholder' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>

  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.heartlands.select_taxrule' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.heartlands.select_taxrule_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-money"></i></span>
        <p-dropdown [options]="taxes" [(ngModel)]="config.TaxRuleID"
                    placeholder="{{'onboarding.heartlands.select_taxrule_placeholder' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>



  <div class="row margin-top-8">
    <div class="col-md-8 label"></div>
    <div class="col-md-4">
      <button type="submit" class="iso-round-button" style="float: right;"
              (click)="updateConfig()"
              [disabled]="busy || !config.StationID || !config.TaxRuleID">{{ busy ? ('onboarding.button.please_wait' | translate) : (config.StationID && config.TaxRuleID) ? ('onboarding.button.update_config' | translate) : ('onboarding.button.set_config' | translate)}}</button>
    </div>
  </div>

</div>

<!--Bit of a stuff up because of the dark UI in the wizard and light wizard in the portal, this is a shared compnent :(-->
<div *ngIf="isWizard">
  <div class="row margin-top-32 help-row">
    <div class="col-md-12">
      <div class="p-float-label">
        <p-dropdown [options]="locations" [(ngModel)]="config.StationID"
          (onChange)="onStationChange($event)"
          placeholder="{{'onboarding.heartlands.select_station_placeholder' | translate}}">
        </p-dropdown>
        <label>{{'onboarding.heartlands.select_station' | translate}}</label>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.heartlands.select_station_info' | translate}}"></span>
  </div>

    <div class="row margin-top-32 help-row">
    <div class="col-md-12">
      <div class="p-float-label">
        <p-dropdown [options]="taxes" [(ngModel)]="config.TaxRuleID"
                    placeholder="{{'onboarding.heartlands.select_taxrule_placeholder' | translate}}">
        </p-dropdown>
        <label>{{'onboarding.heartlands.select_taxrule' | translate}}</label>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.heartlands.select_taxrule_info' | translate}}"></span>
  </div>

  <div class="row margin-top-32">
    <div class="col-md-12">
      <button type="submit" class="iso-round-button" style="float: right;"
              (click)="updateConfig()"
              [disabled]="busy || !config.LocationID">{{ busy ? ('onboarding.button.please_wait' | translate) : (config.LocationID) ? ('onboarding.button.update_config' | translate) : ('onboarding.button.set_config' | translate)}}</button>
    </div>
  </div>
  <div class="row margin-top-32">
    <div class="col-md-12">
      <button pButton (click)="skipToHubtiger()" class="p-button alternate full-width"
              label="{{ 'onboarding.button.skip_to_hubtiger' | translate}}"></button>
      <!--          todo (dcorbett) - removed *ngIf="!configurationSaved"-->
    </div>
  </div>
</div>


<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
